import React, { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import Spinner from "react-bootstrap/Spinner";

export const Loading = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const showTimeout = setTimeout(() => {
      setShow(true);
    }, 1000);
    return () => {
      clearTimeout(showTimeout);
    };
  }, []);

  if (!show) {
    return null;
  }

  return (
    <div className="text-center mt-3 mb-3">
      <Spinner animation="border" role="status">
        <span className="visually-hidden">
          <FormattedMessage id="component.common.loading.loading" />
        </span>
      </Spinner>
    </div>
  );
};
